import { useState } from "react";
import { Dialog } from "primereact/dialog";
import Textarea from "../../../componentes/input/textarea";
import Button from "../../../componentes/button/button";
import { processoInfo } from "../../../utils/solicitacoes/processoRegistry";

// Confirmação de cancelamento pelo solicitante — motivo obrigatório, encerra o workflow
// independentemente da etapa atual. `onConfirmar` deve retornar a Promise da chamada ao backend.
export default function CancelarSolicitacaoModal({ visible, solicitacao, onFechar, onConfirmar }) {
    const [motivo, setMotivo] = useState("");
    const [enviando, setEnviando] = useState(false);

    function fechar() {
        if (enviando) return;
        setMotivo("");
        onFechar();
    }

    function confirmar() {
        if (!motivo.trim()) return;
        setEnviando(true);
        onConfirmar(motivo.trim())
            .then(() => setMotivo(""))
            .catch(() => {})
            .finally(() => setEnviando(false));
    }

    if (!solicitacao) return null;

    const processoLabel = processoInfo(solicitacao.tipoProcesso)?.label || solicitacao.tipoProcesso;

    return (
        <Dialog
            header="Cancelar Solicitação"
            visible={visible}
            onHide={fechar}
            blockScroll
            className="w-[95%] max-w-lg"
            footer={
                <div className="flex justify-end gap-3">
                    <Button variant="outline" label="Voltar" onClick={fechar} disabled={enviando} />
                    <Button
                        variant="red"
                        label="Cancelar Solicitação"
                        iconLeft="fa fa-ban"
                        loading={enviando}
                        disabled={!motivo.trim()}
                        onClick={confirmar}
                    />
                </div>
            }
        >
            <div className="p-4 flex flex-col gap-4">
                <p className="text-sm text-foreground">Tem certeza que deseja cancelar esta solicitação?</p>

                <div className="grid grid-cols-2 gap-3 text-sm rounded-lg bg-muted px-4 py-3">
                    <div>
                        <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Solicitação</span>
                        <span className="block text-foreground font-medium">{solicitacao.numero}</span>
                    </div>
                    <div>
                        <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Processo</span>
                        <span className="block text-foreground font-medium">{processoLabel}</span>
                    </div>
                </div>

                <p className="text-xs text-destructive">
                    <i className="fa fa-exclamation-triangle mr-1" />
                    Essa ação encerrará a solicitação e ela não poderá continuar pelo fluxo normal.
                </p>

                <Textarea
                    id="motivo-cancelamento"
                    label="Motivo do cancelamento"
                    required
                    placeholder="Informe o motivo..."
                    value={motivo}
                    onChange={e => setMotivo(e.target.value)}
                    rows={3}
                />
            </div>
        </Dialog>
    );
}
